// 여기에 게시판에 올릴 글을 넣으면 됩니다.

const noticeData = [
  {
    id: 3,
    title: '산불소화시설 설치 및 운영 관리 지침',
    author: '관리자',
    date: '2026.05.13',
    content: `
                산불의 예방과 진화를 윟 도입한 산불소화시설의 설치 및 운영·관리의 지침입니다.
                http://www.kffmsa.kr/admin/admin_board_01/data/%EC%82%B0%EB%B6%88%EC%86%8C%ED%99%94%EC%8B%9C%EC%84%A4_%EC%84%A4%EC%B9%98_%EB%B0%8F_%EC%9A%B4%EC%98%81_%EA%B4%80%EB%A6%AC_%EC%A7%80%EC%B9%A8_2024%EB%85%84_%EA%B0%9C%EC%A0%95.pdf

                출처 : 한국산림재난안전기술공단
    `.trim(),

  },
  {
    id: 2,
    title: '홈페이지 리뉴얼 알려드립니다.',
    author: '관리자',
    date: '2026.05.13',
    content: `
                안녕하십니까. 대건이앤에스 관리자입니다.

                2026년 05월 13일 리뉴얼된 홈페이지를 오픈하였으며,
                보다 편리하게 정보를 확인하실 수 있도록 구성하였습니다.

                많은 관심 부탁드립니다.
    `.trim(),
  },
  {
    id: 1,
    title: '개인정보처리방침',
    author: '관리자',
    date: '2026.05.13',
    content: `
        대건이앤에스는 개인정보 보호 관련 법령을 준수하며,
        이용자의 개인정보를 안전하게 관리하기 위해 최선을 다하고 있습니다.

        자세한 사항은 개인정보처리방침 내용을 참고해 주시기 바랍니다.
    `.trim(),
  },
];

export default noticeData;